import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router doesn't scroll to #anchors on client-side navigation, so links
// like "/#plans" (nav "Pricing", footer "Plans"/"FAQ") did nothing. Page content
// is lazy-loaded, so retry briefly until the target exists. Without a hash this
// does nothing, so each page's own scroll-to-top behavior is untouched.
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer: ReturnType<typeof setTimeout>;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (tries++ < 20) {
        timer = setTimeout(attempt, 50);
      }
    };
    attempt();
    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
